export default __webpack_public_path__ + "static/media/57t.2490a7db.jpg";